import React from 'react';

const ErrorDisplay = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`auth-error-message auth-error-general ${className}`}>
      {error}
    </div>
  );
};

export default ErrorDisplay;

